import {EventBus} from "../app/libs/event-bus";

import Vue from 'vue';

import VueTheMask from 'vue-the-mask'
import {req} from "vuelidate/lib/validators/common";
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueParticles from 'vue-particles'
import {datePick} from "../app/libs/datepick";
window.Vue = Vue;
window.EventBus = EventBus;
import VueNativeNotification from 'vue-native-notification';
import VueClipboard from 'vue-clipboard2';
import VueTelInput from 'vue-tel-input'

VueClipboard.config.autoSetContainer = true

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAG_oTGaS8WqV9BmqRBY8QmfNDUA4KyL6g",
    authDomain: "getorder-88bef.firebaseapp.com",
    projectId: "getorder-88bef",
    storageBucket: "getorder-88bef.firebasestorage.app",
    messagingSenderId: "825949043834",
    appId: "1:825949043834:web:7c30106bf8ba4a0bb74fc3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


Vue.filter('toCurrency', function (value) {
	if (typeof value !== "number") {
		value = parseInt(value);
	}

	let formatter = new Intl.NumberFormat('ru-Ru', {
		// style: 'currency',
		//  currency: 'UAH',
		minimumFractionDigits: 0
	});
	return formatter.format(value).replace(".",'');
});

Vue.filter('getCurrency', function (value) {

});

import { MonthPicker } from 'vue-month-picker'
import { MonthPickerInput } from 'vue-month-picker'

Vue.use(VueTelInput)
Vue.use(MonthPicker)
Vue.use(MonthPickerInput)
Vue.use(VueNativeNotification, {
    // Automatic permission request before
    // showing notification (default: true)
    requestOnNotify: true
});

Vue.filter('formatDate', function(value) {
	if (value) {
		return moment(String(value)).format('DD/MM/YYYY')
	}
});

Vue.mixin({
	methods: {
        get_datepickLang() {
            return datePick.lang;
        },
		__t(key,def) {
			let newKey = key;
			let newDef = def;
			newDef = newDef === undefined ? newKey : newDef;
			newKey = newKey.toUpperCase();

			if (typeof localStorage !== 'undefined' && localStorage.getItem('debug_lang')) {
				return '**' + newKey + '**';
			}

			let result = lang_constants[newKey] !== undefined ? lang_constants[newKey] : newDef;

			return result;
		},

		is_valid_url(url_check) {
			let url;

			try {
				url = new URL(url_check);
			} catch (_) {
				return false;
			}
			return url.protocol === "http:" || url.protocol === "https:";
		},

		__l(obj, type, name) {
			let args = [];
			if (type === 'warn') {
				args = [
					'%c ' + name + ': %c',
					'background: red',
					'background: yellow',
					obj
				];
			}

			if (type === 'ok') {
				args = [
					'%c ' + name + ' : %c',
					'background: green',
					'background: white',
					obj
				];
			}

			if (type === 'info') {
				args = [
					'%c ' + name + ' : %c',
					'background: steelblue',
					'background: yellow',
					obj
				];
			}

			console.log.apply(console, args);
		},

		obj_to_null(someObject){
			if(someObject == null ) {
				return null;
			}

			let res = Object.keys(someObject).length;

			if(res === 0) {
				return null;
			}

			return someObject;
		}
	},

	filters: {
		uppercase: function (value) {
			if (!value) return '';
			value = value.toString();
			return value.toUpperCase();
		},
	},
});


Vue.use(VueParticles);
Vue.use(VueTheMask);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

Vue.use(VueClipboard);
